import React from "react";

const Heading3= ({text}) =>{
    return (
        <h2 className="mb-[8px] text-[18px] text-[#254774] font-bold">{text}</h2>
    )
}

export default Heading3;